import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import * as lmsActions from 'Container/LeadManagementForm/action';
import { setActiveOverlay, openOverlay } from 'Container/App/action';
import { selectors as mapStateToProps } from './selector';
import { mountLmsForm } from './util/mountLmsForm';
import { LMS_NAMESPACE } from 'Container/App/constants';
import saga from './saga';
import lmsReducer from './reducer';
import { LMModuleHtmlId, LmsHtmlId, OverlayContent } from '../../enums/elementId';
import { mountButtonLink } from '../../components/buttonLink';
import { LmsOpener } from './interface';
import { mountNotification } from '../../components/notification';
import { showLmsResult } from './util/lmsNotification';
import { INotificationProperties } from '@vfde-brix/ws10/notification';
import { NO_PATTERN_BUSINESS_LOGIC, toggleElementVisibility } from '@vfde-brix/ws10/core';
import { trackLMFormOpen } from '../../util/tracking';
import { getUpdateFlags } from './util/state';
import { updateSubmitButtonState } from '../../components/button';

export type State = ReturnType<typeof mapStateToProps>;
const mapDispatch = {
    ...lmsActions,
    setActiveOverlay,
    openOverlay,
};
type Actions = typeof mapDispatch;

function container (_: State, actions: Actions) {
    injectSaga(LMS_NAMESPACE, saga);
    injectReducer(LMS_NAMESPACE, lmsReducer);

    // LMS opener button-link on the landingPage
    mountButtonLink(LMModuleHtmlId.BUTTON_LINK, () => {
        actions.openOverlay(OverlayContent.LMS_MODULE);
        actions.setLmsOpener(LmsOpener.LANDING_PAGE);
    });

    const form = mountLmsForm(actions);

    const backBtn = mountButtonLink(
        LmsHtmlId.WRAPPER_BTN_LMS_BACK,
        () => actions.setActiveOverlay(OverlayContent.RESULT)
    );
    const notificationBaseProps: INotificationProperties = {
        optState: 'success',
        optBackground: 'white',
        txtContent: '',
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
    const notification = mountNotification(
        LmsHtmlId.WRAPPER_NOTIFICATION_RESULT,
        notificationBaseProps
    );
    const errorNotification = mountNotification(
        LmsHtmlId.WRAPPER_NOTIFICATION_ERROR,
        { ...notificationBaseProps, optState: 'error' }
    );

    return {
        getDerivedStateFromProps(newState: State, oldState: State) {
            const update = getUpdateFlags(newState, oldState);

            if (update.isLmsOpened) {
                // clear previous LMS result on open
                actions.clearLmsResult();
                trackLMFormOpen();
            }

            if (update.opener) {
                backBtn && toggleElementVisibility(
                    backBtn,
                    newState.openedBy === LmsOpener.RESULT_SCREEN
                );
            }

            update.lmsResult && showLmsResult(
                notification,
                errorNotification,
                newState.responseData,
            );

            update.isFormChanged && updateSubmitButtonState(
                form.submitButton,
                newState.formData
            );
        },
    };
}

const Container = connect(mapStateToProps, mapDispatch)(container);

export default Container;
